import {INPUT_TYPES} from '../../../../forms/enums/InputTypes';
import {DateFieldEdit} from './DateFieldEdit';
import {DateFieldView} from './DateFieldView';
import {DurationFieldEdit} from './DurationFieldEdit';
import {DurationFieldView} from './DurationFieldView';
import {ListFieldEdit} from './ListFieldEdit';
import {ListFieldView} from './ListFieldView';
import {ScaleFieldEdit} from './ScaleFieldEdit';
import {ScaleFieldView} from './ScaleFieldView';
import {TextLongFieldEdit} from './TextLongFieldEdit';
import {TextLongFieldView} from './TextLongFieldView';
import {TextShortFieldEdit} from './TextShortFieldEdit';
import {TextShortFieldView} from './TextShortFieldView';


export const EditFields = {
  [INPUT_TYPES.date]: DateFieldEdit,
  [INPUT_TYPES.duration]: DurationFieldEdit,
  [INPUT_TYPES.list]: ListFieldEdit,
  [INPUT_TYPES.scale]: ScaleFieldEdit,
  [INPUT_TYPES.text_long]: TextLongFieldEdit,
  [INPUT_TYPES.text_short]: TextShortFieldEdit,
};

export const ViewFields = {
  [INPUT_TYPES.date]: DateFieldView,
  [INPUT_TYPES.duration]: DurationFieldView,
  [INPUT_TYPES.list]: ListFieldView,
  [INPUT_TYPES.scale]: ScaleFieldView,
  [INPUT_TYPES.text_long]: TextLongFieldView,
  [INPUT_TYPES.text_short]: TextShortFieldView,
};



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/index.js